export default {
    form: {
        title: 'Send feedback',
        caption: {
            opener: 'Your opinion is important to us!',
            text: 'Do you have questions, criticism or suggestions about the Trendmanager? Feel free to share your experiences and wishes with us here.',
            signature: 'Your Trendone Team'
        },
        subject: 'Subject',
        feedback: 'Feedback',
        submit: 'Submit',
        validation: {
            email: 'Please enter a valid email address',
            feedback: 'This field must not be empty'
        }
    },
    create: {
        success: 'Feedback successfully sent'
    }
}
